import angular from 'angular';
import { ssDialogService } from 'app/services';
import controller from './view-webinar-dialog.controller';
import template from './view-webinar-dialog.html';

export class dialogService {
  getOptions($event, {
    mediaUrl,
    webinarHeight,
    webinarWidth,
  }) {
    return {
      controller,
      controllerAs: 'viewWebinarDialogVM',
      locals: {
        mediaUrl,
        webinarHeight,
        webinarWidth,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.support.viewWebinarDialog', [
  ssDialogService
])
  .service('viewWebinarDialog', dialogService)
  .name;

console.log('app.components.support.viewWebinarDialog created');
